import { useLatestEntity, useThunkDispatch } from '@campaignhub/react-hooks'
import { useSelector } from 'react-redux'

import * as serviceJobDetailActions from '@redux/modules/serviceJobDetail'

const upsertServiceJobDetail = (serviceJobDetailParam, dispatch, requestOptions) => {
  const { upsertServiceJobDetail: createFn } = serviceJobDetailActions

  return dispatch(createFn(serviceJobDetailParam, requestOptions))
}

const updateServiceJobDetail = (serviceJobDetailParam, dispatch, requestOptions) => {
  const { updateServiceJobDetail: updateFn } = serviceJobDetailActions

  return dispatch(updateFn(serviceJobDetailParam, requestOptions))
}

const undoRefundServiceJobDetail = (serviceJobDetailParam, dispatch, requestOptions) => {
  const { undoRefundServiceJobDetail: undoRefundFn } = serviceJobDetailActions

  return dispatch(undoRefundFn(serviceJobDetailParam, requestOptions))
}

const useServiceJobDetail = (initServiceJobDetail = {}) => {
  const { entity: serviceJobDetail } = useLatestEntity(initServiceJobDetail, 'serviceJobDetails')

  const dispatch = useThunkDispatch()

  const {
    creating, deleting, loading, updating,
  } = useSelector(reduxState => reduxState.serviceJobDetails)

  return {
    callbacks: {
      updateServiceJobDetail: (serviceJobDetailParam, requestOptions) => updateServiceJobDetail(serviceJobDetailParam, dispatch, requestOptions),
      upsertServiceJobDetail: (serviceJobDetailParam, requestOptions) => upsertServiceJobDetail(serviceJobDetailParam, dispatch, requestOptions),
      undoRefundServiceJobDetail: (serviceJobDetailParam, requestOptions) => undoRefundServiceJobDetail(serviceJobDetailParam, dispatch, requestOptions),
    },
    creating,
    deleting,
    loading,
    serviceJobDetail,
    updating,
  }
}

export default useServiceJobDetail
